import React, { Component, useState, useEffect } from 'react'
import { Box, Button, Heading, Layer, Main, Meter, ResponsiveContext, Sidebar, Text } from 'grommet'
import { History, InProgress } from 'grommet-icons'
import { AnimatePresence } from 'framer-motion'
import { MotionBox, MotionLayer } from './Motion'
import { AppContext } from '../libs/context'
import TimeAgo from 'react-timeago'
import PropTypes from 'prop-types'
import { PageCard } from './Cards'

const statusColor = {
  progressing: 'status-warning',
  succeeded: 'status-ok',
  started: 'dark-3',
  failed: 'status-critical'
}
export const FirebaseBatchJobs = ({ jobs }) => {
  const [expand, setExpand] = useState(false)
  const [active, setActive] = useState(0)
  useEffect(() => {
    let count = 0
    jobs.forEach((job) => {
      if (job.status === 'progressing' || job.status === 'started') {
        count += 1
      }
    })
    setActive(count)
  })
  return (
    <ResponsiveContext.Consumer>
      {(size) => (
        <Box>
          <Button
            primary
            icon={active ? <InProgress size="16px" /> : <History size="18px" color={'light-1'} />}
            hoverIndicator
            fill={'vertical'}
            // active={expand}
            color={expand ? 'dark-1' : active ? 'status-warning' : 'dark-5'}
            label={size !== 'small' && 'Jobs' + (active ? ' running: ' + active : '')}
            onClick={() => setExpand(!expand)}
          />
          <AnimatePresence inital={false}>
            {expand && (
              <MotionLayer
                full={size === 'small' ? true : 'vertical'}
                animate={false}
                plain
                modal={size === 'small'}
                position="right"
                onEsc={() => setExpand(false)}
                onClickOutside={() => setExpand(false)}
              >
                <PageCard
                  show={true}
                  heading={'Jobs History'}
                  margin={{ top: '58px' }}
                  border={{ side: 'left', color: 'light-4' }}
                  closeAction={() => setExpand(false)}
                  background="light-2"
                  variants={{
                    open: { opacity: 1, x: 0 },
                    collapsed: { opacity: 0, x: 500 }
                  }}
                  initial="collapsed"
                  animate="open"
                  exit="collapsed"
                  transition={{
                    type: 'spring',
                    duration: 0.7,
                    staggerChildren: 0.07,
                    delayChildren: 0.2
                  }}
                >
                  <Main
                    // height={'50vw'}
                    width={size === 'small' ? '100%' : 'medium'}
                    flex={'grow'}
                  >
                    <MotionBox flex={'grow'} pad={'medium'} gap={'xsmall'}>
                      {/*<AnimatePresence inital={false}>*/}
                      {jobs.length === 0 && (
                        <MotionBox
                          key={'empty'}
                          pad={'medium'}
                          round={'small'}
                          margin={{ bottom: 'xsmall' }}
                          background={'light-3'}
                          initial={{ opacity: 0, scale: 0 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0 }}
                          transition={{ type: 'spring', duration: 0.7 }}
                        >
                          <Text weight={'bold'} color={'dark-6'}>
                            I am empty :(
                          </Text>
                        </MotionBox>
                      )}
                      {jobs.map((job) => (
                        <MotionBox
                          key={job.id}
                          margin={{ bottom: 'xsmall' }}
                          // initial={{ opacity: 0, scale: 0 }}
                          // animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0 }}
                          variants={{
                            collapsed: { opacity: 0, x: 150 },
                            open: { opacity: 1, x: 0 }
                          }}
                          transition={{ type: 'spring', duration: 0.7 }}
                          flex={false}
                        >
                          <FirebaseJob {...job} />
                        </MotionBox>
                      ))}
                      <MotionBox key={'end'} pad={'medium'} />
                      {/*</AnimatePresence>*/}
                    </MotionBox>
                  </Main>
                </PageCard>
              </MotionLayer>
            )}
          </AnimatePresence>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
}
FirebaseBatchJobs.propTypes = {
  jobs: PropTypes.array
}

const FirebaseJob = ({ name, total, processed, status, ...job }) => {
  const [jobType, idType, id] = job.id.split('_')
  const niceNameByType = {
    publish: 'Publish'
  }
  let jobName = niceNameByType[jobType]

  return (
    <Box
      gap="medium"
      pad="medium"
      round="small"
      width="medium"
      // height="small"
      align="center"
      justify="center"
      background="white"
      elevation="large"
      direction={'row'}
      flex={false}
    >
      <AppContext.Consumer>
        {({ companies, receivers }) => (
          <Box gap="xsmall" fill="horizontal" align="start" justify="center">
            <Text truncate weight="bold" size={'small'} color={'mesh-purple-1'} margin={'none'}>
              {name ? name : jobName ? jobName : job.id}
              {idType === 'company' && companies[id] && ' ' + companies[id].name}
              {idType === 'receiver' && receivers[id] && ' ' + receivers[id].name}
              {idType === 'id' && ' ID ' + id}
              {idType === 'all' && ' All'}
            </Text>

            <Meter
              thickness="small"
              type="bar"
              round
              size={'full'}
              max={total}
              values={[
                {
                  value: processed,
                  label: 'completed',
                  color: statusColor[status],
                  highlight: true,
                  onClick: () => {}
                },
                {
                  value: total,
                  label: 'total',
                  color: 'light-1',
                  onClick: () => {}
                }
              ]}
              aria-label="meter"
            />
            <Box gap={'xsmall'} direction="row" justify={'between'} fill={'horizontal'}>
              <Text size={'xsmall'} color="dark-3">
                {processed} of {total}
              </Text>
              <Text size={'xsmall'} color="dark-6">
                {job.updated_at && <TimeAgo date={job.updated_at.toDate()} />}
              </Text>
            </Box>
            <Text size="xsmall" weight="bold" color={statusColor[status]}>
              {status}
            </Text>
          </Box>
        )}
      </AppContext.Consumer>

      {/*<Button*/}
      {/*  disabled={chunking}*/}
      {/*  label="DONE"*/}
      {/*  onClick={() => {*/}
      {/*    this.changeStatus('WORKFLOW DONE')*/}
      {/*  }}*/}
      {/*/>*/}
    </Box>
  )
}
FirebaseJob.propTypes = {
  total: PropTypes.number,
  processed: PropTypes.number,
  status: PropTypes.string,
  name: PropTypes.string
}
